<template>
  <v-fade-transition mode="out-in">
    <router-view/>
  </v-fade-transition>
</template>

<script>
import {Component, Vue} from 'vue-property-decorator';
import '@/styles/overrides.sass';

@Component({
  components: {},
})
export default class App extends Vue {

  name = 'Nexomed';
  metaInfo = {
    title: 'Nexomed',
    titleTemplate: '%s | Financeiro',
    htmlAttrs: {lang: 'en'},
    meta: [
      {charset: 'utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
    ],
  }
}
</script>
